import React from 'react';
import logo from './logo.svg';
import './App.css';
import LayoutArea from './components/LayoutArea/LayoutArea';




function App() {
  return (
    <div className="App">
      
      <LayoutArea />
      {/* <RandomNumbersComponent/> */}
    
    </div>
  );
}

export default App;
